import z from '../../../../node_modules/zod/lib/index.js';

const issueFormSchema=z.object({complaintReason:z.string({required_error:"replacement.issue.form.invalid_reason"}).refine(reason=>reason!=="0","replacement.issue.form.invalid_reason"),complaintDescription:z.string({required_error:"replacement.issue.form.invalid_description"}).min(15,"replacement.issue.form.invalid_description_length"),files:z.any({required_error:"replacement.issue.form.invalid_files"})});

export { issueFormSchema };
//# sourceMappingURL=IssueFormValidation.js.map
